import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '@/environments/environment';
import {Page} from '@/app/core/models/page';
import {Observable} from 'rxjs';
import {PlaceLeaderboard} from '@/app/core/models/p-place/pixel';

@Injectable({
	providedIn: 'root'
})
export class PlaceLeaderboardService {

	constructor(
		private readonly http: HttpClient
	) {}

	private readonly SERVICE_URI = `${environment.backendUrl}/place/leaderboard`;

	getLeaderboard(page: number = 0): Observable<Page<PlaceLeaderboard>> {
		const params = new HttpParams().set('page', page);

		return this.http.get<Page<PlaceLeaderboard>>(
			this.SERVICE_URI,
			{ params }
		);
	}

}
